<template>
  <div class="pay">
    <div class="navbar_style" :class="$store.state.user.isNested && 'navbar_style_nested'">
      <Icon
          class="navbar_icon"
          name="arrow-left"
          @click="
          $router.push({ path: '/detail', query: { busiId: payInfo.busiId } })
        "
      />
      <span>{{ l.bank_pay_immediately }}</span>
      <div class="icon_box"></div>
    </div>
    <div class="pay_box" :class="$store.state.user.isNested && 'pay_box_nested'">
      <div class="change_limit_con">
        <div class="title">
          <span>{{ l.bank_repay_sum }}</span>
        </div>
        <div class="divCenter">
          <div class="curLoanMoney">
            <span class="symbol">NT$</span>{{ formatMoney(pageData.amount) }}
          </div>
        </div>
      </div>
      <div class="pay_container_box">
        <div class="pay_item_box">
          <div class="pay_item_title">第一步：請先確認還款金額，再前往還款</div>
          <div class="pay_item_info">
            <div class="pay_item_info_item">
              <div class="pay_item_info_item_label">
                {{ l.bank_repay_sum }}：
              </div>
              <div class="pay_item_info_item_value">
                NT${{ formatMoney(pageData.amount) }}
              </div>
            </div>
            <Button
                size="normal"
                type="info"
                block
                class="pay_item_info_repayment"
                @click="handleToRepayment"
            >
              <img src="@/assets/order/dor.png" alt="">
              前往還款
            </Button>
            <!--            <div class="pay_item_info_con">-->
            <!--              <div class="pay_item_info_con_title">收款銀行：</div>-->
            <!--              <div class="pay_item_info_con_desc">{{pageData.bank_name}}</div>-->
            <!--            </div>-->
            <!--            <div class="pay_item_info_con">-->
            <!--              <div class="pay_item_info_con_title">收款賬戶：</div>-->
            <!--              <div class="pay_item_info_con_desc">-->
            <!--                {{pageData.va}}-->
            <!--                <div @click="onCopy(pageData.va)" class="pay_item_info_con_desc_copy">複製</div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
        <div class="pay_item_box">
          <div class="pay_item_title">第二步：還款完成後，請上傳還款單的截圖</div>
          <div class="pay_item_voucher">
            <div class="pay_item_voucher_title">還款單截圖</div>
            <div class="pay_item_voucher_desc">
              <img v-if="file" @click="file = undefined" class="pay_item_voucher_desc_close"
                   src="@/assets/my/close@2x.png" alt="">
              <img class="pay_item_voucher_desc_img" src="@/assets/order/photo.png" alt="">
              <input class="hide_file" ref="leftFile" id="upload" capture="camera" type="file" @change="getFile($event)"
                     accept="image/*">
            </div>
          </div>
        </div>
      </div>
      <div class="pay_btn_box">
        <Button
            size="normal"
            type="info"
            block
            class="pay_btn"
            @click="handleCompleteBtn"
        >完成
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import {Icon, Toast, Button} from "vant";
import {formatMoney} from "@/utils";
import {getva} from "@/services/order";
import l from "@/locales";
import {lrzUploadRepayVouch} from "@/services/upload";

export default {
  name: "immediately",
  data() {
    return {
      pageData: {},
      order: undefined,
      curIndex: 0,
      l: {...l.repayMethods, ...l.orderItem, ...l.home, ...l.router},
      payInfo: {},
      file: undefined,
    };
  },
  components: {Icon, Button},
  methods: {
    formatMoney,
    handleToRepayment() {
      window.location.href = this.pageData.va;
    },
    // 获取选择的图片文件上传
    getFile(e) {
      let file = e.target.files[0];
      this.file = file;
      console.log(file);
    },
    handleCompleteBtn() {
      if (!this.file) {
        Toast("請先上傳還款單截圖");
        return;
      }
      let {application_id, vaType} = this.payInfo;
      console.log("this.pageData", this.pageData)
      // let { va } = this.resData;
      let params = {
        application_id,
        vaType,
        // cardNo: va,
        cardNo: this.pageData.card_no,
        amount: this.pageData.amount,
        // bankCardNo: this.pageData.b,
        file: this.file,
      };
      console.log("params", params);
      // this.$tools.androidMethod("sendOffline", params, "getSendOffline");
      lrzUploadRepayVouch(params, (res) => {
        if (res) {
          Toast("上傳成功");
          setTimeout(() => {
            this.$router.push({path: '/detail', query: {busiId: this.payInfo.busiId}})
          }, 2000)
        }
        console.log("lrzUploadRepayVouchres", res);
      });
    },
    // 点击触发input的点击事件
    clickFile() {
      this.$refs.leftFile.click();
    },
    onCopy(str) {
      let url = str;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      Toast("複製成功!");
      oInput.remove();
    },
    getAmount() {
      let order = this.order;
      order.loan_status += "";
      let amount;
      switch (order.loan_status) {
        case "1":
        case "2":
        case "3":
        case "5":
          amount = order.amount2Account;
          break;
        case "4":
        case "6":
          amount = order.remainAmount;
          break;
        case "9":
          amount = order.reach_amount;
          break;
      }
      // if(amount.includes(",")){
      //     amount = amount.replaceAll(",","");
      // }
      // amount = 20000000;
      if(order.vaType == 1){
        amount = order.amount;
      }
      return amount;
    },
    async init(data) {
      this.order = data;


      const params = {
        amount: this.getAmount(),
        bank_code: this.order.bank_code,
        atm_otc: 2,
        vaType: this.order.vaType,
        application_id: this.order.application_id,
      };
      let res = await getva({
        ...data,
        ...params,
      });
      console.log("resss", res);
      if (res.code == 200) {
        this.pageData = res.result;
      }
      // data.repaymentMethods = ["online", "offline"];
      // data.repaymentMethods = ["offline"];
    },
  },
  created() {
    this.init(JSON.parse(localStorage.getItem("androidData") || "{}"));
    this.payInfo = JSON.parse(localStorage.getItem("payInfo") || "{}");
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.pay {
  position: relative;
  height: 100%;
  min-height: 100vh;
  background: #F8FBFF;

  .pay_box {
    position: absolute;
    top: 30px;
    left: 0;
    box-sizing: border-box;
    width: 100%;
    padding-top: 20px;

    &_nested {
      top: 70px;
    }


    .change_limit_con {
      position: relative;
      margin: 0 15px;
      font-family: PingFangSC-Semibold;
      font-size: 20px;
      color: #333333;
      box-sizing: border-box;

      width: calc(100% - 30px);
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      border: 1px solid #BDDCFF;
      height: 103px;
      background: linear-gradient(180deg, #E6F0FB 0%, rgba(255, 255, 255, 0) 100%);

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        background: linear-gradient(180deg, #E6F0FB 0%, rgba(255, 255, 255, 0) 100%);
      }

      .title {
        position: absolute;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        width: 100%;
        text-align: center;
        box-sizing: border-box;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #445144;

      }

      .symbol {
        margin-right: 6px;
      }

      .divCenter {
        position: absolute;
        top: 54px;
        left: 50%;
        transform: translateX(-50%);

        width: 55px;
        height: 29px;
        background: url("~@/assets/home/lineWire.png") no-repeat;
        background-size: 100% 100%;
        padding: 0 35px;
        box-sizing: border-box;

        display: flex;
        align-items: center;
        justify-content: center;

        .curLoanMoney {
          text-align: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 24px;
          color: #2A333C;

        }

      }
    }

    .pay_container_box {
      margin: 0 25px;
      margin-top: 30px;

      .pay_item_box {
        position: relative;
        padding-left: 20px;
        padding-bottom: 40px;
        box-sizing: border-box;
        transform: translateY(-10px);

        background: linear-gradient(
                to bottom,
                transparent 0%,
                transparent 50%,
                rgba(41, 128, 246, 0.7) 50%,
                rgba(41, 128, 246, 0.7) 100%
        );
        background-size: 1px 10px;
        background-repeat: repeat-y;

        &:first-child {
          transform: translateY(0);
        }

        &:last-child {
          background: none;
          padding-bottom: 20px;
        }

        &:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          transform: translateX(-50%);
          background: url("~@/assets/order/ball.png") no-repeat;
          background-size: 100% 100%;
          width: 20px;
          height: 20px;
        }

        .pay_item_title {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          height: 20px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #555555;
        }

        .pay_item_info {
          margin-top: 10px;
          padding: 15px;
          padding-right: 0;
          box-sizing: border-box;
          background: #FFFFFF;
          box-shadow: 0px 0px 5px 0px rgba(56, 151, 229, 0.2);
          border-radius: 10px;

          .pay_item_info_item {
            display: flex;
            align-items: center;
            justify-content: center;

            .pay_item_info_item_label {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 14px;
              color: #28435B;
            }

            .pay_item_info_item_value {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 14px;
              color: #FF8700;
              margin-left: 5px;
            }
          }

          .pay_item_info_repayment {
            margin: 0 auto;
            margin-top: 15px;
            width: 150px;
            height: 30px;
            background: rgba(16, 103, 219, 0.1);
            border-radius: 15px;
            border: 1px solid #2980F6;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #2980F6;

            img {
              width: 16px;
              height: 17px;
            }
          }

          .pay_item_info_con {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-bottom: 10px;

            &:last-child {
              margin-bottom: 0;
            }

            .pay_item_info_con_title {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 14px;
              color: #28435B;
            }

            .pay_item_info_con_desc {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              flex-wrap: wrap;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 14px;
              color: #5C778F;

              .pay_item_info_con_desc_copy {
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 11px;
                color: #2488DA;

                padding: 4px 11px;
                box-sizing: border-box;
                background: rgba(36, 136, 218, 0.13);
                border-radius: 16px;

                margin-left: 10px;
              }
            }
          }
        }

        .pay_item_voucher {
          margin-top: 10px;
          padding: 15px;
          padding-right: 0;
          box-sizing: border-box;
          background: #FFFFFF;
          box-shadow: 0px 0px 5px 0px rgba(56, 151, 229, 0.2);
          border-radius: 10px;
          width: 175px;
          height: 147px;

          .pay_item_voucher_title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #5C778F;
          }

          .pay_item_voucher_desc {
            position: relative;
            margin-top: 10px;

            .pay_item_voucher_desc_close {
              position: absolute;
              top: 0;
              right: 15px;
              width: 15px;
              height: 15px;
            }

            .pay_item_voucher_desc_img {
              width: 145px;
              height: 90px;
              border-radius: 4px;
            }

            .hide_file {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              opacity: 0;
            }
          }
        }
      }
    }

    .pay_btn_box {
      display: flex;
      align-items: center;
      justify-content: center;

      .pay_btn {
        width: 275px;
        height: 48px;
        background: linear-gradient(180deg, #A5D1FA 0%, #3F8FFB 100%);
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        border-radius: 25px;
        border: none;
      }
    }
  }
}
</style>
